<template>
    <div class="contentBox">
        <div class="setWrap">
            单价在<el-input :class="{ 'error': !isMoreEq }" size="mini" v-model="moreEq" />~<el-input :class="{ 'error': !isLess }" size="mini" v-model="less" />元（{{moreEq}} ≤ X < {{less}}）之间，复本数为<el-input-number size="mini" v-model="copy" :min="1" :max="100"></el-input-number>
        </div>    
        <p class="errortip">{{ errTxt }}</p>
        <div class="btn_box" style="padding-top:30px;text-align: center;">
            <el-button class="btn_add_canle" size="mini" @click="cancel">取消</el-button>
            <el-button class="btn_add_sure" size="mini" type="primary" @click="submitSave">保存</el-button>
        </div>
    </div>
</template>

<script>
import {Input, Button, InputNumber} from 'element-ui'
export default {
    props:[ 'type', 'ruledata' ],
    data(){
        return {
            reg: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
            isMoreEq: true,
            isLess: true,
            errTxt: '',
            copy: '',
            less: 100,
            moreEq: 0,
            // numRule: {
            //     copy: '',
            //     less: 100,
            //     moreEq: 0
            // }
        }
    },
    components:{ 'el-input': Input, 'el-button': Button, 'el-input-number': InputNumber },
    watch:{
        moreEq(val, oldVal){
            if(val == ''){
                this.isMoreEq = false;
                this.errTxt = '请输入起始值！';
            }else{
                if(this.reg.test(val)){
                    if(Number(val) > Number(this.less)){
                        this.isMoreEq = false;
                        this.errTxt = '起始值不能大于终止值！';
                    }else{
                        this.isMoreEq = true;
                        this.isLess = true;
                        this.errTxt = '';
                    }
                }else{
                    this.isMoreEq = false;
                    this.errTxt = '请输入正确金额！';
                }
            }
        },
        less(val, oldVal){
            if(val == ''){
                this.isLess = false;
                this.errTxt = '请输入起始值！';
            }else{
                if(this.reg.test(val)){
                    if(Number(val) < Number(this.moreEq)){
                        this.isLess = false;
                        this.errTxt = '终止值不能小于起始值！';
                    }else{
                        this.isMoreEq = true;
                        this.isLess = true;
                        this.errTxt = '';
                    }
                }else{
                    this.isLess = false;
                    this.errTxt = '请输入正确金额！';
                }
            }
        }
    },
    created(){
        let vm = this;
        if(vm.type == '1'){
            for(var a in vm.ruledata){
                vm[a] = vm.ruledata[a];
            }
        }
    },
    mounted(){

    },
    methods:{
        //取消
        cancel(){
            let vm = this;
            vm.$emit('close');
        },
        //保存
        submitSave(){
            let vm = this;
            if(vm.isMoreEq && vm.isLess){
                vm.errTxt = '';
                if(vm.type == '0'){
                    vm.$emit('submit', {
                        copy: vm.copy,
                        less: vm.less,
                        moreEq: vm.moreEq
                    });
                }else{
                    vm.$emit('submit', {
                        id: vm.ruledata.id,
                        copy: vm.copy,
                        less: vm.less,
                        moreEq: vm.moreEq
                    });
                }
            }
        }
    }
}
</script>

<style lang="scss" scope>   
.contentBox{
    .setWrap{
        text-align: center;
        font-size: 12px;
        padding: 10px 0;
        color: #666;
        >.el-input{
            width: 45px;
            margin:0px 6px;
            &.error{
                .el-input__inner{
                    border-color: #f56c6c;
                }
            }
        }
        .el-input--mini .el-input__inner{
            text-align: center;
            padding: 0px 8px;
        }
        .el-input-number--mini{
            width:100px;
            margin-left:6px;
            .el-input--mini .el-input__inner{
                padding: 0px 15px;
                width:100px;
            }
        }
    }
    .errortip{
        color: #f56c6c;
        font-size:12px;
        text-align: center;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/setCopyRule.vue